<template>
  <div :class="{ 'opacity-60': locked }">
    <inputPrimaryVue
      :modelValue="telephone"
      @update:modelValue="value => emit('update:telephone', value)"
      :label="t('ownerForm.labels.telephone')"
      :required="!unavailable"
      :help-text="t('ownerForm.telephoneHelp')"
      :placeholder="t('ownerForm.placeholders.telephone')"
      type="tel"
      :disabled="unavailable || locked"
      :class="{ 'border-red-500': invalid }"
    />

    <!-- La excepción aparece recién al intentar guardar sin teléfono del titular,
         o ya marcada si la solicitud se creó con ella. -->
    <template v-if="showsUnavailable">
      <label class="flex items-center gap-2 mt-2" :class="locked ? 'cursor-not-allowed' : 'cursor-pointer'">
        <input
          :id="`telephoneUnavailable${idSuffix}`"
          type="checkbox"
          :checked="unavailable"
          :disabled="locked"
          @change="event => emit('update:unavailable', event.target.checked)"
          class="w-4 h-4"
          :class="{ 'telephone-locked': locked }"
        />
        <span class="text-sm" :class="locked ? 'text-gray-500' : 'text-gray-700'">
          {{ t('ownerForm.telephoneUnavailable.label') }}
        </span>
      </label>
      <p class="text-xs text-gray-500 mt-1 leading-4">
        {{ t('ownerForm.telephoneUnavailable.declaration') }}
      </p>
    </template>

    <!-- Al modificar la solicitud se respeta lo que indicó el cliente (el número
         o la excepción): queda en gris y solo se desbloquea a propósito. -->
    <div v-if="locked" class="flex flex-wrap items-baseline gap-x-2 gap-y-1 mt-2">
      <p class="text-xs text-gray-500">{{ t('ownerForm.telephoneLocked.note') }}</p>
      <button
        type="button"
        class="text-xs text-[var(--c-primary)] underline"
        data-testid="telephone-unlock"
        @click="emit('unlock')"
      >
        {{ t('ownerForm.telephoneLocked.change') }}
      </button>
    </div>

    <span v-if="invalid" class="text-red-500 text-sm">
      {{ t('ownerForm.errors.telephone.invalid') }}
    </span>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import inputPrimaryVue from '@/components/inputs/input-primary.vue';

defineProps({
  /** Sufijo del id de la casilla, para que no se repita si el bloque sale más de una vez. */
  idSuffix: { type: String, required: true },
  telephone: { type: [String, Number], default: '' },
  unavailable: { type: Boolean, default: false },
  showsUnavailable: { type: Boolean, default: false },
  /** Teléfono de la solicitud original: se muestra pero no se toca. */
  locked: { type: Boolean, default: false },
  invalid: { type: Boolean, default: false },
});

const emit = defineEmits(['update:telephone', 'update:unavailable', 'unlock']);
const { t } = useI18n();
</script>

<style scoped>
/* Bloqueada, la marca de «No dispongo» sigue bien visible (como los consentimientos). */
.telephone-locked {
  accent-color: #6b7280;
  opacity: 1;
}
</style>
